export const sleep = async (sec: number) =>
    new Promise((resolve) => {
        setTimeout(() => {
            resolve(null)
        }, sec * 1000)
    })
